import React from "react";
import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridExportCsvOptions,
} from "@material-ui/x-grid";
import Box from "@material-ui/core/Box";

import GridToolbarQuickFilterField from "./GridToolbarQuickFilterField";
import GridToolbarFullscreenButton from "./GridToolbarFullscreenButton";

export type Feature =
  | "FilterButton"
  | "ColumnsButton"
  | "DensitySelector"
  | "Export"
  | "Fullscreen"
  | "QuickFilter";

export type Features = {
  [key in Feature]?: boolean;
};

const csvOptions: GridExportCsvOptions = {
  allColumns: true,
};

export interface Options {
  fileName?: string;
}

export interface CreateToolBarArg {
  features?: Features;
  options?: Options;
}

export const DefaultFeatures: Features = {
  FilterButton: true,
  ColumnsButton: true,
  DensitySelector: true,
  Export: true,
  Fullscreen: false,
  QuickFilter: true,
};

export const createTableToolbar = ({
  features = DefaultFeatures,
  options = {},
}: CreateToolBarArg = {}) => {
  const Component = function TableToolbar({
    quickFilter,
    onQuickFilterChange,
    onQuickFilterBlur,
    onFullscreenClick,
  }) {
    return (
      <GridToolbarContainer>
        {features["FilterButton"] ? <GridToolbarFilterButton /> : null}
        {features["ColumnsButton"] ? <GridToolbarColumnsButton /> : null}
        {features["DensitySelector"] ? <GridToolbarDensitySelector /> : null}
        {features["Export"] ? (
          <GridToolbarExport
            csvOptions={
              options?.fileName
                ? {
                    ...csvOptions,
                    fileName: options.fileName,
                  }
                : csvOptions
            }
          />
        ) : null}
        {features["Fullscreen"] || features["QuickFilter"] ? (
          <Box flex={1} />
        ) : null}
        {features["Fullscreen"] ? (
          <GridToolbarFullscreenButton onFullscreenClick={onFullscreenClick} />
        ) : null}
        {features["QuickFilter"] ? (
          <GridToolbarQuickFilterField
            quickFilter={quickFilter}
            onQuickFilterChange={onQuickFilterChange}
            onBlur={onQuickFilterBlur}
          />
        ) : null}
      </GridToolbarContainer>
    );
  };

  Component.displayName = `TableToolbar(${Object.entries(features)
    .filter(([k, v]) => v)
    .map(([k, v]) => k)
    .join(", ")})`;

  return Component;
};

const TableToolbar = createTableToolbar();

export default TableToolbar;
